import { proNavigator } from "single-spa/react-app/ProNavigator";

const KEYWORD_ANALYSIS_STATE = "organicsearch_keywordAnalysis_overview_2";

// Value of EKWGeneratorTableTabs.relatedKeywords (keyword-research zone), inlined as a string
// literal to avoid a cross-zone import that violates the market-research architecture boundary.
const RELATED_KEYWORDS_TAB = "relatedKeywords";

export const getKeywordAnalysisHref = (keyword: string): string =>
    proNavigator.getStateUrl(KEYWORD_ANALYSIS_STATE, {
        ...proNavigator.getParams(),
        tab: RELATED_KEYWORDS_TAB,
        keyword: encodeURIComponent(keyword),
    });
